/* Docked rail. An in-flow column that pushes and shrinks the main editor
   (no overlay), filling the builder's height. Colors/spacing come from
   Astryx tokens; the fixed width and the height-fill are the bespoke layout
   Astryx can't express. */

.expanded {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  width: 260px;
  padding: var(--spacing-3);
  border-radius: var(--radius-container);
  border: 1px solid var(--color-border);
  background: var(--color-background-card);
}

.list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

@media (max-width: 720px) {
  .expanded {
    flex: initial;
    width: 100%;
  }
}
